import { Link } from "react-router-dom";
import { Helmet } from "react-helmet-async";

function Home() {
  return (
    <div
      className="min-h-[calc(100vh-136px)] flex flex-col items-center justify-center bg-cover bg-center relative"
      style={{
        backgroundImage: `url('https://images.unsplash.com/photo-1602407294553-6ac9170b3ed0?q=80&w=2874&auto=format&fit=crop&ixlib=rb-4.0.3&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D')`,
      }}
    >
      <Helmet
        htmlAttributes={{
          lang: "en",
        }}
      >
        <meta charSet="utf-8" />
        <meta name="viewport" content="width=device-width, initial-scale=1" />
        <meta name="theme-color" content="#2563EB" />
        <title>Build Pro Resume - Create a Professional Resume Instantly</title>
        <meta
          name="description"
          content="Build an ATS-friendly resume in seconds with our free, easy-to-use resume builder. No sign-up required!"
        />
        <meta
          name="keywords"
          content="Free Resume Builder, ATS Resume, Resume Generator, Online Resume, Job Application, Professional CV"
        />
        <meta
          name="robots"
          content="index, follow, max-snippet:-1, max-image-preview:large, max-video-preview:-1"
        />
        <link rel="canonical" href="https://buildproresume.com/" />

        <link
          rel="apple-touch-icon"
          sizes="180x180"
          href="/icons/apple-touch-icon.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="32x32"
          href="/icons/favicon-32x32.png"
        />
        <link
          rel="icon"
          type="image/png"
          sizes="16x16"
          href="/icons/favicon-16x16.png"
        />
        <link rel="manifest" href="/site.webmanifest" />
        <link
          rel="mask-icon"
          href="/icons/safari-pinned-tab.svg"
          color="#2563EB"
        />
        <meta name="msapplication-TileColor" content="#2563EB" />
        <meta name="theme-color" content="#2563EB" />

        <link
          rel="preload"
          as="image"
          href="https://images.unsplash.com/photo-1602407294553-6ac9170b3ed0?q=80&w=2874&auto=format&fit=crop"
        />

        <meta property="og:locale" content="en_US" />
        <meta property="og:type" content="website" />
        <meta property="og:site_name" content="Build Pro Resume" />
        <meta
          property="og:title"
          content="Build Pro Resume - Create a Job-Winning Resume Instantly"
        />
        <meta
          property="og:description"
          content="Generate an ATS-optimized resume in minutes. Choose from professional templates and get hired faster!"
        />
        <meta property="og:url" content="https://buildproresume.com/" />
        <meta
          property="og:image"
          content="https://buildproresume.com/logo.png"
        />
        <meta property="og:image:alt" content="Build Pro Resume Logo" />

        <meta name="twitter:card" content="summary_large_image" />
        <meta
          name="twitter:title"
          content="Build Pro Resume - Job-Winning Resumes in Seconds"
        />
        <meta
          name="twitter:description"
          content="Create a stunning, ATS-friendly resume in a few clicks. Free & easy to use!"
        />
        <meta
          name="twitter:image"
          content="https://buildproresume.com/preview-image.png"
        />
        <meta name="twitter:image:alt" content="Build Pro Resume Preview" />
      </Helmet>

      {/* 🔹 Overlay */}
      <div className="absolute inset-0 bg-black bg-opacity-40"></div>

      {/* 🔹 Main Content */}
      <div className="relative z-10 text-center px-6 max-w-3xl">
        <h1 className="text-4xl md:text-5xl font-extrabold text-white drop-shadow-lg mb-6">
          Build Your <span className="text-blue-400">Job-Winning Resume</span>{" "}
          Today!
        </h1>

        <p className="text-lg text-gray-200 mb-8 max-w-lg mx-auto">
          Create an ATS-friendly resume in just a few clicks. No sign-up, no
          hassle, just results!
        </p>

        <Link
          to="/resume"
          className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-8 py-4 rounded-lg shadow-lg transition-transform transform hover:scale-105"
        >
          Start Now – It's Free!
        </Link>

        {/* 🔹 Expanded Content for Word Count */}
        <div className="mt-10 text-gray-200 text-sm leading-relaxed">
          <p className="mb-4">
            We focus on simplicity, speed, and results. With no sign-up required, you can start
            building your resume instantly and download it in multiple formats. All resumes follow
            best practices to ensure compatibility with Applicant Tracking Systems used by companies
            worldwide.
          </p>
          <p className="mb-6">
            Join other job seekers who trust Build Pro Resume to get noticed and get hired.
            Ready to make your move? Click the button above to get started — it’s completely free.
          </p>
        </div>

        {/* 🔹 Additional Links */}
        <div className="mt-8">
          <p className="text-gray-200 mb-4">Visit our other sites:</p>
          <div className="space-x-4">
            <a
              href="https://hashtagenius.com"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-blue-500 hover:bg-blue-600 text-white font-semibold px-6 py-3 rounded-lg shadow-lg transition-transform transform hover:scale-105"
            >
              Hashtagenius
            </a>
            <a
              href="https://minilo.blog"
              target="_blank"
              rel="noopener noreferrer"
              className="bg-green-500 hover:bg-green-600 text-white font-semibold px-6 py-3 rounded-lg shadow-lg transition-transform transform hover:scale-105"
            >
              Minilo Blog
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Home;
